import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Table, FormCheck } from 'react-bootstrap';
import ApiService from '../../services/ApiService';
import FileNotFound from '../FileNotFound';
import toastr from '../toastr';
import SubscriptionCategory from './SubscriptionCategory';
import LoadingPage from '../LoadingPage';

const Subscriptions = () => {
  const [loading, setLoading] = useState(true);
  const [subscriptions, setSubscriptions] = useState([]);
  const user = useSelector(state => state.app.user);

  const getSubscriptions = () => {
    ApiService.get('subscriptions', { userId: user.id }).then(response => {
      setSubscriptions(response.data);
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleChange = (event, type, subscriptionId) => {
    const value = event.target.checked;
    ApiService.put('subscriptions', { subscriptionId, type, value })
      .then(() => {})
      .catch(err => {
        event.target.checked = !value;
        toastr.error('Error', err.message);
      });
  };

  useEffect(() => {
    getSubscriptions();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  if (!subscriptions.length) {
    return <FileNotFound>There are currently no subscriptions available</FileNotFound>;
  }

  // Create Categories (as keys) with subs array as the value
  const subsByCat = {};
  subscriptions.forEach(sub => {
    if (!subsByCat[sub.category]) {
      subsByCat[sub.category] = [];
    }

    subsByCat[sub.category].push(sub);
  });

  return (
    <div className="sub-list">
      <div
        className="d-inline-block p-2 mr-1 rounded"
        style={{ backgroundColor: 'var(--primary-color)', color: 'var(--primary-fore)' }}
      >
        <i className="fas fa-phone mr-1" />
        {user.phone || '<None>'}
      </div>
      <div
        className="d-inline-block p-2 mr-1 rounded"
        style={{ backgroundColor: 'var(--primary-color)', color: 'var(--primary-fore)' }}
      >
        <i className="fas fa-envelope mr-1" />
        {user.email}
      </div>
      <Table>
        <thead>
          <tr>
            <td>Name</td>
            <td>
              <i className="fas fa-sms fa-2x" />
            </td>
            <td>
              <i className="fas fa-envelope fa-2x" />
            </td>
            <td>
              <i className="fas fa-bell fa-2x" />
            </td>
          </tr>
        </thead>
        {Object.keys(subsByCat).sort().map(category => {
          const subsInCat = subsByCat[category];
          return (
            <tbody key={category}>
              <SubscriptionCategory category={category}>
                {subsInCat.map(subscription => {
                  return (
                    <React.Fragment key={subscription.id}>
                      <tr style={{ backgroundColor: '#fff' }}>
                        <td>
                          <strong>{subscription.title}</strong>
                        </td>
                        <td>
                          <FormCheck>
                            <FormCheck.Input
                              type="checkbox"
                              onChange={event => handleChange(event, 'bySMS', subscription.id)}
                              defaultChecked={subscription.bySMS}
                            />
                          </FormCheck>
                        </td>
                        <td>
                          <FormCheck>
                            <FormCheck.Input
                              type="checkbox"
                              onChange={event => handleChange(event, 'byEmail', subscription.id)}
                              defaultChecked={subscription.byEmail}
                            />
                          </FormCheck>
                        </td>
                        <td>
                          <FormCheck>
                            <FormCheck.Input
                              type="checkbox"
                              onChange={event => handleChange(event, 'byNotification', subscription.id)}
                              defaultChecked={subscription.byNotification}
                            />
                          </FormCheck>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4} style={{ padding: '10px 25px' }}>
                          {subscription.description}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </SubscriptionCategory>
            </tbody>
          );
        })}
      </Table>
    </div>
  );
};

export default Subscriptions;
